import { IconButton, Stack, styled } from '@mui/material';

import {
  colorPrimaryFocusStyle,
  colorPrimaryHoverStyle,
} from '../../../../styles/mui/components/shared';

type ComposeModalHeaderProps = {
  'data-is-post': boolean;
};

export const ActionButton = styled(IconButton)(() => ({
  '&:focus-visible': {
    boxShadow: 'none',
  },
  borderRadius: 'var(--border-radius-large)',
  display: 'inline-flex',
  height: 'fit-content',
  padding: 'var(--spacing-small)',
}));

export const ModalHeader = styled('header')<ComposeModalHeaderProps>(
  ({ theme, 'data-is-post': isPost }) => ({
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    borderBottomColor: theme.palette[isPost ? 'secondary' : 'tertiary'].main,
    borderBottomStyle: 'solid',
    borderBottomWidth: 'var(--spacing-small)',
    borderTopLeftRadius: 'var(--border-radius-medium)',
    borderTopRightRadius: 'var(--border-radius-medium)',
    color: theme.palette.primary.contrastText,
    display: 'flex',
    flexDirection: 'row',
    gap: 'var(--spacing-small)',
    justifyContent: 'space-between',
    paddingBlock: 'calc(var(--spacing-small) + var(--spacing-tiny))',
    paddingInline: 'calc(var(--spacing-large) + var(--spacing-small))',
  }),
);

export const ModalHeaderActions = styled(Stack)(({ theme }) => ({
  '& .MuiIconButton-root': {
    '&:focus': {
      ...colorPrimaryFocusStyle,
    },
    '&:hover': {
      ...colorPrimaryHoverStyle,
    },
  },
  '& svg': {
    color: theme.palette.primary.contrastText,
  },
  flexDirection: 'row',
  gap: 'var(--spacing-medium)',
}));

export const ModalHeaderMainContent = styled(Stack)(() => ({
  alignItems: 'center',
  flexDirection: 'row',
  gap: 'var(--spacing-small)',
}));

export const ModalTitle = styled('h3')(() => ({
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 'var(--preference-button-line-clamp)',
  display: '-webkit-box',
  fontSize: 'var(--font-lg)',
  fontWeight: 'var(--font-bold)',
  overflow: 'hidden',
  textWrap: 'wrap',
}));
